import { LearningMapRequestData } from '@/models/LearningMapRequestData';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import Constants from '../../Constants';
import { CurrentLearningMapRequest } from '../../models/CurrentLearningMapRequest';
import http from '../../services/HttpService';
import {
    getCurrentLearningMapFailure,
    getCurrentLearningMapSuccess,
    getHistoryLearningMapFailure,
    getHistoryLearningMapSuccess,
    saveCurrentLearningMapFailure,
    saveCurrentLearningMapSuccess,
    getWordCloudCategoriesDataSuccess,
    getWordCloudCategoriesDataFailure,
} from './action';
import { LearningMapTypes, WordCloudCategoriesDataRequest } from './types';

export function* getCurrentLearningMapRequest(action: PayloadAction<LearningMapTypes.GET_CURRENT_LEARNING_MAP_REQUEST, CurrentLearningMapRequest>) {
    try {
        const { withTotalFinishedContents, withMediaTypeConsumption } = action.payload;
        const params = `?withTotalFinishedContents=${withTotalFinishedContents || false}&withMediaTypeConsumption=${withMediaTypeConsumption ||
            false}`;
        const response = yield call(http.get, Constants.CAST_CURRENT_LEARNING_MAP_URI + params);
        yield put(getCurrentLearningMapSuccess(response.data));
    } catch (error) {
        yield put(getCurrentLearningMapFailure(error));
    }
}

export function* saveCurrentLearningMapRequest(action: PayloadAction<LearningMapTypes.SAVE_CURRENT_LEARNING_MAP_REQUEST, LearningMapRequestData>) {
    try {
        yield call(http.post, Constants.CAST_CURRENT_LEARNING_MAP_URI, action.payload);
        yield put(saveCurrentLearningMapSuccess());
    } catch (error) {
        yield put(saveCurrentLearningMapFailure());
    }
}

export function* getHistoryLearningMapRequest() {
    try {
        const response = yield call(http.get, Constants.CAST_HISTORY_LEARNING_MAP_URI);
        yield put(getHistoryLearningMapSuccess(response.data));
    } catch (error) {
        yield put(getHistoryLearningMapFailure());
    }
}

export function* getWordCloudCategoriesDataRequest(action: PayloadAction<LearningMapTypes.GET_WORDCLOUD_CATEGORIES_DATA_REQUEST, WordCloudCategoriesDataRequest>) {
    try {
        const { moduleIds } = action.payload;
        const response = yield call(http.get, `${Constants.CAST_PERSON_CATEGORIES_DATA_URI}?moduleIds=${moduleIds}`);
        yield put(getWordCloudCategoriesDataSuccess(response.data));
    } catch (error) {
        yield put(getWordCloudCategoriesDataFailure());
    }
}
